import { render, staticRenderFns } from "./TaskInfoModalUser.vue?vue&type=template&id=11653370&scoped=true"
import script from "./TaskInfoModalUser.vue?vue&type=script&lang=js"
export * from "./TaskInfoModalUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11653370",
  null
  
)

export default component.exports